import React from 'react';
import classNames from 'classnames';

import { Props } from './DefaultItem';

import styles from '../ProductDescription.module.scss';

function DescriptionItem({ attrCode, content }: Props): JSX.Element {
  return (
    <div className={classNames(styles[attrCode], styles.attrLines)}>
      <p
        dangerouslySetInnerHTML={{
          __html: content,
        }}
        className={styles.content}
      />
    </div>
  );
}

export default DescriptionItem;
